module.exports = __webpack_public_path__ + "img/EMT-PRCA_SpatialResearch.cb746030.png";